
import { firestore } from 'firebase/app';

export class ProductData {

	title: string;
	description: string;
	date: firestore.Timestamp | Date;
	expiration: firestore.Timestamp | Date;
	file?: string;
}

export class Product extends ProductData {

	id: string;
}